import * as financialImpact from './financialImpact'
import * as horizontTags from './horizontTags'
import * as portfolio from './portfolio'
import * as portfolioColumn from './portfolioColumn'
import * as portfolioInvite from './portfolioInvite'
import * as project from './project'
import * as projectComments from './projectComments'
import * as projectInvite from './projectInvite'
import * as projectTaskComments from './projectTaskComments'
import * as projectTasks from './projectTasks'
import * as riscTags from './riscTags'
import * as tags from './tags'

export const projectService = {
  portfolio: {
    create: portfolio.createPortfolio,
    delete: portfolio.deletePortfolio,
    get: portfolio.getPortfolios,
    getPortfolioId: portfolio.getPortfolioId,
    update: portfolio.updatePortfolio,
    getPortfolioTags: portfolio.getPortfolioTags,
    getPublicPortfolioId: portfolio.getPublicPortfolioId,
    getUsersPortfolio: portfolio.getUsersPortfolio,
    changePermissionUserPortfolio: portfolio.changePermissionUserPortfolio,
    deleteUserMemberPortfolio: portfolio.deleteUserMemberPortfolio,
    getPortfolioGantt: portfolio.getPortfolioGantt,
    updateProjectByGantt: portfolio.updateProjectByGantt,
    getPortfolioProjectTags: portfolio.getPortfolioProjectTags,
  },
  portfolioInvite: {
    inviteUser: portfolioInvite.createPortfolioInvite,
    delete: portfolioInvite.deletePortfolioInvite,
  },
  portfolioColumn: {
    get: portfolioColumn.getPortfolioColumns,
    create: portfolioColumn.createPortfolioColumn,
    update: portfolioColumn.updatePortfolioColumn,
    delete: portfolioColumn.deletePortfolioColumn,
  },
  project: {
    get: project.getPortfolioProjects,
    getProject: project.getPortfolioProject,
    create: project.createPortfolioProject,
    update: project.updatePortfolioProject,
    delete: project.deletePortfolioProject,
    updatePosition: project.updatePositionPortfolioProject,
    getUsersProject: project.getUsersProject,
    archive: project.archivePortfolioProject,
    unarchive: project.unarchivePortfolioProject,
    changePermissionUserProject: project.changePermissionUserProject,
    changePrivacyProject: project.changePrivacyProject,
    deleteUserMemberProject: project.deleteUserMemberProject,
    getMyProjects: project.getMyProjects,
    getMyProject: project.getMyProject,
    getMyCountProjects: project.getMyCountProjects,
    getProjectHistory: project.getProjectHistory,
  },
  projectInvite: {
    inviteUser: projectInvite.inviteUserProject,
    getUsersProjectInvite: projectInvite.getUsersProjectInvite,
    addResponsible: projectInvite.addResponsible,
  },
  horizontTags: {
    get: horizontTags.getHorizontTags,
  },
  riscTags: {
    get: riscTags.getRiscTags,
  },
  tags: {
    linkToProject: tags.linkTagToProject,
    getTags: tags.getTags,
    createTag: tags.createTag,
    updateTag: tags.updateTag,
    deleteTag: tags.deleteTag,
  },
  projectTasks: {
    createTask: projectTasks.createTask,
    deleteTask: projectTasks.deleteTask,
    getTask: projectTasks.getTask,
    getTasks: projectTasks.getTasks,
    updateTask: projectTasks.updateTask,
    updatePositionTask: projectTasks.updatePositionTask,
  },
  projectTaskComments: {
    createTaskComment: projectTaskComments.createTaskComment,
    deleteTaskComment: projectTaskComments.deleteTaskComment,
    getTaskComments: projectTaskComments.getTaskComments,
    updateTaskComment: projectTaskComments.updateTaskComment,
  },
  projectComments: {
    createComment: projectComments.createComment,
    deleteComment: projectComments.deleteComment,
    getComments: projectComments.getComments,
    updateComment: projectComments.updateComment,
  },

  financialImpact: {
    create: financialImpact.createFinancialImpact,
    update: financialImpact.updateFinancialImpact,
    get: financialImpact.getFinancialImpactByProjectId,
  },
}
